import React from 'react'
import { DatePicker as BaseDatePicker } from 'baseui/datepicker'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { SpacingWrapper } from '@/shared/theme/styled-components'
import useIdentity from './useIdentity'
import pickedDayAsIso from '@/shared/tools/pickedDayAsIso'

const DatePicker = BaseDatePicker as React.ComponentType<any>

const IdentityFormFields = () => {
  const {
    t,
    isEditable,
    documentType,
    documentNumber,
    expirationDate,
    createdDate,
    issuingEntity,
    issuingCity,
    documentTypeOptions,
    updateIdentity,
  } = useIdentity()

  return (
    <>
      {/* @ts-ignore */}
      <SDSelect
        label={t('subscriptionForm:identity_module.document_type.label')}
        disabled={isEditable === false}
        selectedValue={documentType ?? ''}
        optionsList={documentTypeOptions}
        placeholder={t('subscriptionForm:identity_module.document_type.placeholder')}
        onChangeHandler={(params: { value: Array<{ id: string }> }) => {
          updateIdentity({ documentType: params.value[0]?.id ?? '' })
        }}
        newTranslations
        translationsPath='subscriptionForm:identity_module.document_type_options.'
      />

      <SpacingWrapper $marginTop='1rem'>
        <SDInput
          id='input-document-number'
          label={t('subscriptionForm:identity_module.document_number.label')}
          disabled={isEditable === false}
          currentValue={documentNumber ?? ''}
          onBlur={(value: string | null) => updateIdentity({ documentNumber: value ?? '' })}
          error={false}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SpacingWrapper>

      <SDFormControl label={t('subscriptionForm:identity_module.expired_date.label')}>
        <DatePicker
          placeholder='DD/MM/YYYY'
          clearable
          disabled={isEditable === false}
          value={expirationDate}
          minDate={new Date(Date.now())}
          formatString='dd/MM/yyyy'
          onChange={({ date }: { date: Date | Date[] | null }) => {
            if (!date) {
              updateIdentity({ expirationDate: null })
              return
            }
            updateIdentity({ expirationDate: pickedDayAsIso(date) })
          }}
        />
      </SDFormControl>

      <SDFormControl label={t('subscriptionForm:identity_module.creation_date.label')}>
        <DatePicker
          placeholder='DD/MM/YYYY'
          clearable
          disabled={isEditable === false}
          value={createdDate}
          maxDate={new Date(Date.now())}
          formatString='dd/MM/yyyy'
          onChange={({ date }: { date: Date | Date[] | null }) => {
            if (!date) {
              updateIdentity({ createdDate: null })
              return
            }
            updateIdentity({ createdDate: pickedDayAsIso(date) })
          }}
        />
      </SDFormControl>

      <SpacingWrapper $marginTop='1rem'>
        <SDInput
          id='input-issuing-entity'
          label={t('subscriptionForm:identity_module.issuing_entity.label')}
          disabled={isEditable === false}
          currentValue={issuingEntity ?? ''}
          onBlur={(value: string | null) => updateIdentity({ issuingEntity: value ?? '' })}
          error={false}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SpacingWrapper>

      <SpacingWrapper $marginTop='1rem'>
        <SDInput
          id='input-issuing-city'
          label={t('subscriptionForm:identity_module.issuing_city.label')}
          disabled={isEditable === false}
          currentValue={issuingCity ?? ''}
          onBlur={(value: string | null) => updateIdentity({ issuingCity: value ?? '' })}
          error={false}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SpacingWrapper>
    </>
  )
}

export default IdentityFormFields
